import { render, staticRenderFns } from "./StudentExamPage.vue?vue&type=template&id=4a7d2e6e&scoped=true&"
import script from "./StudentExamPage.vue?vue&type=script&lang=js&"
export * from "./StudentExamPage.vue?vue&type=script&lang=js&"
import style0 from "./StudentExamPage.vue?vue&type=style&index=0&id=4a7d2e6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7d2e6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
